import React, { useState } from 'react';
import { SendEmailInputForm } from 'features/authentication/components/send-email-input-form/send-email-input-form';
import {
    EmailDataFormParameters,
    SplunkReportConfig,
} from 'store/auth/actions/auth-actions/auth-action-types';
import { TEXTS } from 'features/authentication/sso/components/sso-page/constants';
import { Banner, Heading, UtilityAlertIcon } from '@placer-ui/components';
import { shouldRenderMobileApp } from 'utils/detect-environment';
import { OrDivider } from 'features/authentication/components/or-divider/or-divider';
import { GoToAuthPageButton } from 'features/authentication/sso/components/go-to-auth-page-button.tsx/go-to-auth-page-button';
import { sendEmailErrorMessagesText } from 'features/authentication/utils/utils';
import { PrivacyDisclaimer } from 'features/authentication/components/privacy-disclaimer/privacy-disclaimer';
import styles from './sso-page.module.scss';

type SsoPageProps = {
    onSendEmail: (data: EmailDataFormParameters) => Promise<number>;
    onSuccessCallback: (value: string) => void;
    email?: string;
    isLoginMode: boolean;
};

export const SsoPage = ({ onSendEmail, onSuccessCallback, email, isLoginMode }: SsoPageProps) => {
    const isMobile = shouldRenderMobileApp();
    const [errorCode, setErrorCode] = useState(0);
    const { label, goToAuthPageButtonLabel } = isLoginMode ? TEXTS.login : TEXTS.signup;

    const onFailure = (email: string, error: SplunkReportConfig) => {
        setErrorCode(error.statusCode);
    };

    return (
        <>
            {errorCode !== 0 && (
                <div className={styles.errorBannerContainer}>
                    <Banner
                        LeftIcon={<UtilityAlertIcon />}
                        text={sendEmailErrorMessagesText[errorCode]}
                        type="error"
                    />
                </div>
            )}
            <div className={styles.ssoPageContainer}>
                <Heading variant={isMobile ? 'h3' : 'h2'} testId={`${label}-sso-header`}>
                    {label} with SSO
                </Heading>
                <div className={styles.body}>
                    <SendEmailInputForm
                        sendEmail={onSendEmail}
                        onSuccessCallback={onSuccessCallback}
                        onFailureCallback={onFailure}
                        isRecaptchaEnabled={false}
                        email={email}
                        submitButtonLabel={label}
                        setParentErrorCode={setErrorCode}
                        inputTestId={'sso-email-input'}
                        submitEmailButtonTestId={'login-sso-page-login-button'}
                    />
                    <OrDivider />
                    <GoToAuthPageButton isLoginMode={isLoginMode} label={goToAuthPageButtonLabel} />
                </div>
            </div>
            {!isLoginMode && (
                <div className={styles.privacyDisclaimer}>
                    <PrivacyDisclaimer />
                </div>
            )}
        </>
    );
};
